"use client";

import styles from "./LoginAuthenticationForm.module.scss";
import classNames from "classnames";

import { GoogleSignInButton } from "@/components";
import { isGoogleOAuthConfigured } from "@/constants";

import { useGoogleAuth } from "@/hooks";
import { createForm } from "@/stores";
import { useEffect } from "react";
import { useTranslations } from "@/i18n";

import {
  LoginRememberMeCheckbox,
  LoginForgotPasswordLink,
  LoginPasswordInput,
  LoginEmailInput,
  LoginSubmitButton,
} from "..";
import { Flex } from "@vetty/ui";

/**
 * LoginAuthenticationForm Component
 *
 * Complete authentication form with optional Google OAuth and email/password login.
 * Handles form initialization, loading states, and user authentication flow.
 */
export const LoginAuthenticationForm = () => {
  const t = useTranslations("login.form");
  const googleEnabled = isGoogleOAuthConfigured();

  // Google OAuth state for loading management
  const googleAuthState = useGoogleAuth();

  // Initialize form with required fields
  useEffect(() => {
    createForm(["email", "password"]);
  }, []);

  return (
    <Flex direction={"column"} className={styles["comp"]}>
      {googleEnabled && <GoogleSignInButton />}

      {googleEnabled && (
        <Flex className={styles["comp__or"]} align={"center"} gap={8}>
          <div className={styles["comp__or__line"]}></div>
          <div className={styles["comp__or__label"]}>{t("or")}</div>
          <div className={styles["comp__or__line"]}></div>
        </Flex>
      )}

      {/* Email/password form section */}
      <Flex
        direction={"column"}
        className={classNames(
          styles["comp__content"],
          googleAuthState.loading && styles["comp__content--disabled"]
        )}
      >
        <Flex direction={"column"} gap={40} className={styles["comp__form"]}>
          {/* Form inputs section */}
          <Flex direction={"column"} gap={24}>
            {/* Email and password inputs */}
            <LoginEmailInput />
            <LoginPasswordInput />

            {/* Form options row */}
            <Flex justify={"space-between"} align={"center"}>
              <LoginRememberMeCheckbox />
              <LoginForgotPasswordLink />
            </Flex>

            {/* Submit button */}
            <LoginSubmitButton />
          </Flex>
        </Flex>
      </Flex>
    </Flex>
  );
};
